
const ENUMS = {
    cv : {
        id: 0,
        type:"",
        jobHash: "",
        scoreSummary:{
            score: 0,
            applicationDetailsScore: {
                id: false,
                coverLetter: false,
                grammar: 0,
                relevance: 0,
            },
            personalDetailsScore: {
                name:false,
                dob: false,
                contactable: false,
                rsaCitizen: false,
                driversLicense: false,
                linkedIn: false
            },
            educationScore: {
                releventEducation:0,
                completionTime: 0,
            },
            experienceScore: {
                noJobHopping: false,
                currentlyEmployed: false,
                releventExperience:0,
                sufficientExperience: 0,
                grammar: 0,
                relevant: 0,
                workHistory: 0,
                averageScore: 0,
            },
            skillsScore: {
                relevantSkill:0,
                currentSkill: 0,
                yearsExperience: 0,
                skillLevel: 0,
            },
            additionalQuestionsScore: {
                hybrid:false,
                cities: false,
                salaryBand: false,
                noticePeriod: false,
            },
        },
        personalDetails: {
            candidateSummary: "",
            name: "",
            surname: "",
            preferredName: "",
            dob: "",
            email: "",
            gender: "",
            phoneNum: "",
            city: "",
            province: "",
            address: "",
            rsaCitizen: true,
            idNumber: "",
            ethnicity: "",
            driversLicense: false,
            primaryLanguage: "",
            secondaryLanguage: "",
            disabled: false,
            disabilityDescription: "",
            websiteURL: "",
        },
        skills: [{
            skill: "",
            level: "",
            years: "",
            current: ""
        }],
        education: [{
            institution: "",
            qualification: "",
            qualificationType: "",
            startDate: "",
            dateAttained: "",
        }],
        experience: [{
            graduate: "",
            employerName: "",
            jobTitle: "",
            roleDescription: "",
            startDate: "",
            endDate: "",
            current: "",
            workModel: "",
            employmentType: "",
            industryType: "",
            technologiesUsed: "",
            country: "",
            city: ""
        }],
        additionalQuestions: {
            cityWork: "",
            hybrid: "",
            currentSalary: "",
            expectedSalary: "",
            lastIncreaseDate: "",
            whyWorkWebtonic: "",
            consentCriminalCheck: false,
            consentCreditCheck: false,
            noticePeriod: "",
            popi:false,
        },
    },
    EXTERNAL_CV: 'External_CV',
    MyCV: 'MyCV',
    job: {
        jobTitle: "",
        dateModified: "",
        department: "",
        hashCode: "",
        salaryDetails: {
            salaryBand: "",
            medicalAid: false,
            leave: 0,
            bonus: "",
            lifeAndDisabilityInsurance: false,
            pension : false,
            trainingBudget: false,
        },
        jobDetails: {
            description: "",
            rolesResponsibilities: "",
            jobType: "",
            jobCategory: "",
            fromDate: "",
            toDate: "",
            workModel: "",
            hybridDays: 0,
            jobPlacement: [],
            industry: "",
            jobFunction: "",
            jobStatus: "",
            skills: [{
                skill: "",
                level: "",
                years: "",
                current: ""
            }]
        },
    },
    InternalConsultant: 'InternalConsultant',
    primaryLanguage: [
            {
                value: "Eng",
                label: "English",
            },
            {
                value: "Afr",
                label: "Afrikaans",
            },
            {
                value: "Xho",
                label: "isiXhosa",
            },
            {
                value: "Fre",
                label: "French",
            },
            {
                value: "Ger",
                label: "German",
            },
            {
                value: "Spa",
                label: "Spanish",
            },
            {
                value: "Sot",
                label: "Sesotho",
            },
            {
                value: "Xit",
                label: "Xitsonga",
            },
            {
                value: "Set",
                label: "Setswana",
            },
            {
                value: "Zul",
                label: "isiZulu",
            },
            {
                value: "Nde",
                label: "isiNdebele",
            },
            {
                value: "Sep",
                label: "Sesotho sa Leboa",
            },
            {
                value: "Swa",
                label: "siSwati",
            },
            {
                value: "Ven",
                label: "Tshivenda",
            }
    ],
    FeatureFlags: {
        CVParser: 'CVParser'
    },
    textFieldStyle:{
        "& label.Mui-focused": {
            color: "#FF6600",
        },
        "& .MuiOutlinedInput-root": {
            "&.Mui-focused fieldset": {
                borderColor: "#FF6600",
            },
        },
    },
    modalStyle : {position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '50%',
        height: 'auto',
        bgcolor: 'background.paper',
        boxShadow: 24,
        p: 2
    }

};

export default ENUMS; // Export the enum object